document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection slider-component').forEach(slider => {
    const scroller = slider.querySelector('.slider');
    const track = slider.querySelector('.featured-collection-slider-progress__track');
    const fill = slider.querySelector('.featured-collection-slider-progress__fill');

    if (!scroller || !track || !fill) return;

    const update = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;

      const visibleRatio =
        scroller.clientWidth / scroller.scrollWidth;

      const scrollRatio =
        scroller.scrollLeft / maxScroll || 0;

      fill.style.width = `${visibleRatio * 100}%`;
      fill.style.left = `${scrollRatio * (100 - visibleRatio * 100)}%`;
    };

    scroller.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();

    // click / drag support
    track.addEventListener('pointerdown', e => {
      const rect = track.getBoundingClientRect();

      const move = ev => {
        const percent =
          (ev.clientX - rect.left) / rect.width;

        scroller.scrollTo({
          left:
            percent *
            (scroller.scrollWidth - scroller.clientWidth),
          behavior: 'auto'
        });
      };

      move(e);
      document.addEventListener('pointermove', move);
      document.addEventListener(
        'pointerup',
        () =>
          document.removeEventListener('pointermove', move),
        { once: true }
      );
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-list-slider').forEach(wrapper => {
    const slider = wrapper.querySelector('.cls-items');
    const track  = wrapper.querySelector('.collection-list-slider__track');
    const fill   = wrapper.querySelector('.collection-list-slider__fill');

    if (!slider || !track || !fill) return;

    const $slider = $(slider);

    function update(slick) {
      const total  = slick.slideCount;
      const show   = slick.options.slidesToShow;
      const index  = slick.currentSlide || 0;

      if (total <= show) {
        fill.style.width = '100%';
        fill.style.left = '0%';
        return;
      }

      const visibleRatio = show / total;
      const maxIndex = total - show;
      const scrollRatio = index / maxIndex;

      fill.style.width = `${visibleRatio * 100}%`;
      fill.style.left  = `${scrollRatio * (100 - visibleRatio * 100)}%`;
    }

    $slider.on('init reInit afterChange', (e, slick) => update(slick));

    $slider.slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3.4,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1025, settings: { slidesToShow: 2.4 }},
        { breakpoint: 769,  settings: { slidesToShow: 1.6 }},
        { breakpoint: 480,  settings: { slidesToShow: 1.6 }}
      ]
    });

    /* Click / drag progress bar */
    track.addEventListener('pointerdown', e => {
      const slick = $slider.slick('getSlick');
      const rect  = track.getBoundingClientRect();

      const move = ev => {
        const percent = Math.min(
          Math.max((ev.clientX - rect.left) / rect.width, 0),
          1
        );

        const target =
          percent * (slick.slideCount - slick.options.slidesToShow);

        $slider.slick('slickGoTo', Math.round(target));
      };

      move(e);
      document.addEventListener('pointermove', move);
      document.addEventListener(
        'pointerup',
        () => document.removeEventListener('pointermove', move),
        { once: true }
      );
    });
  });
});

$('.blog__posts-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3.4,
  slidesToScroll: 1,        
  swipeToSlide: true,       
  touchThreshold: 10,
  arrows: true,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 3.4, slidesToScroll: 1 } },
    { breakpoint: 768,  settings: { slidesToShow: 2.2, slidesToScroll: 1 } },
    { breakpoint: 480,  settings: { slidesToShow: 1.2, slidesToScroll: 1 } }
  ]
});


// Set the target date to the 15th of the current or next month at 12 AM EST
function getNextDropDate() {
    const now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth(); // 0-indexed
    let targetDate = new Date(Date.UTC(year, month, 15, 5, 0, 0)); // 12AM EST = 5AM UTC

    // If the 15th has already passed, move to next month
    if (now.getTime() > targetDate.getTime()) {
        month += 1;
        if (month > 11) {
            month = 0;
            year += 1;
        }
        targetDate = new Date(Date.UTC(year, month, 15, 5, 0, 0));
    }

    return targetDate;
}

function startCountdown() {
    const countdownEl = document.querySelector('.next-drop-countdown'); // your timer container
    const targetDate = getNextDropDate();

    function updateCountdown() {
        const now = new Date();
        let diff = targetDate - now;

        if (diff < 0) diff = 0;

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const mins = Math.floor((diff / (1000 * 60)) % 60);
        const secs = Math.floor((diff / 1000) % 60);

        countdownEl.innerHTML = `
            <div class="countdown-item"><span class="days">${days}</span><span>days</span></div>
            <div class="countdown-item"><span class="days">${hours}</span><span>hours</span></div>
            <div class="countdown-item"><span class="days">${mins}</span><span>mins</span></div>
            <div class="countdown-item"><span class="days">${secs}</span><span>secs</span></div>
        `;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
}

document.addEventListener('DOMContentLoaded', startCountdown);
